import { UseQueryResult } from "@tanstack/react-query";
import { createContext } from "react";

export interface SuggestedAgendaItemContextProps {
  suggestedAgendaItemsCount: UseQueryResult<number | undefined, Error>;
}

export const SuggestedAgendaItemContext = createContext({} as SuggestedAgendaItemContextProps);
